import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=62c033be&scoped=true&"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./LocaleSwitcher.vue?vue&type=style&index=0&id=62c033be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c033be",
  null
  
)

export default component.exports